module.exports = __webpack_public_path__ + "img/emoji_031.b2ad3968.png";